import React from 'react';
/*
  PLACEHOLDER: "As featured in" press strip.
  Toggle SHOW_FEATURED to true ONLY once you can populate it with REAL
  placements. Replace the placeholder names/logos below with actual outlets.
*/
const SHOW_FEATURED = false;
const PLACEMENTS = ['Outlet One', 'Outlet Two', 'Outlet Three', 'Outlet Four'];
export function FeaturedInStrip() {
  if (!SHOW_FEATURED) return null;
  return <section aria-label="Featured in" className="border-y border-gray-200 bg-gray-50 py-5" data-id="element-82">
      <div className="max-w-3xl mx-auto px-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-8" data-id="element-83">
        <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 whitespace-nowrap" data-id="element-84">
          As featured in
        </span>
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-id="element-85">
          {PLACEMENTS.map(name => <li key={name} className="text-base font-semibold text-gray-400" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-86">
              {name}
            </li>)}
        </ul>
      </div>
    </section>;
}